<template>
  <div class="storyRecomend">
    <div class="listGroup u-mg-b-1"
      data-color="secondary"
      data-size="lg"
      :data-border="dataBorder">
      <div class="listGroup__body">
        <ul>
          <li v-for="recomend in items" :key="recomend.item_id" v-if="!recomend.not_view" class="listGroup__item" data-arrow="false">
              <a class="media g-summaryText"
                :href="inputLink(recomend.item_id)"
                v-if="type === 'text'" @click="sendEventText(recomend.item_id)"
              >
                <div class="media__image" data-size="xm" data-clip-path-support="true">
                  <uranai-img data-clip-path-support="true" data-size="xm" size="xm" :src="recomend.pack_image"></uranai-img>
                </div>

                <div class="media__text">
                  <div class="media__content">
                    <div>
                      <h4 class="media__title">{{ recomend.item_name }}</h4>
                    </div>
                    <div>
                      <p>{{ recomend.easy_explanation }}</p>
                    </div>

                    <div class="rowcontent">
                      <p class="counselorname">占い師：{{ recomend.counselor_name }}</p>
                      <div class="media__description">
                        <div class="media__description_leftbox">
                          <div class="category">
                            <span :class="'badge u-tag-'+recomend.category_tag_id">{{ recomend.category_tag_name }}</span>
                          </div>
                        </div>

                        <div class="tagarea u-tx-right u-width-10" data-color="white" v-if="recomend.price == 0">
                          <span class="pricetag">無料</span>
                        </div>
                        <div class="tagarea u-tx-right u-width-10" data-color="white" v-if="recomend.price > 0">
                          <span class="pricetag notfree">¥{{ recomend.price_taxin }}</span>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </a>
            </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'

export default {
  name: 'story-recomend',
  data() {
    return {
      token: window.Laravel.csrfToken,
      cpno: window.Laravel.cpno
    }
  },
  computed: {
    ...mapState({
      item: state => state.item.selected,
      recomends: state => state.item.recomends
    }),
    ...mapGetters(['hasRecomends'])
  },
  props: {
    items: Array,
    itemsId: String,
    itemScheduleId: String,
    counselorName: String,
    packImage: String,
    type: {
      type: String,
      required: true
    },
    dataBorder: {type: String, default: 'false'},
    dataArray: []
  },
  mounted() {
    this.$store.dispatch(type.RESET_ITEM_RECOMENDS)
    this.$store.dispatch(type.GET_ITEM_RECOMENDS, this.itemsId)
    this.$store.dispatch(type.RESET_SELECTED_ITEM)
    this.$store.dispatch(type.UPDATE_PRODUCT_DETAIL_VISIBILITY, false)

  },
  methods: {
    showProductDetail(item) {
      this.$store.dispatch(type.SELECT_ITEM, { id: item.item_id })
      this.$store.dispatch(type.UPDATE_PRODUCT_DETAIL_VISIBILITY, true)
    },
    inputLink(itemid) {
      //console.log(this.$store.dispatch(type.SELECT_ITEM, { id: recomend.item_id }));
      /**
      * text用
      * 引数に渡ったIDを6桁の文字列に変換する
      * @param { Number } id - item_id
      */
      const parseDigit = (id = 0) => {
        const digit = 6
        let str = ''
        for (let i = 0; i < digit - String(id).length; i++) {
          str += '0'
        }
        str += String(id)
        return str
      }
      if (itemid) {
        return `/contents/${parseDigit(itemid)}/input${
          window.location.search
        }`
      } else {
        return `/`
      }
    },
    // テキスト用：イベント送信
    sendEventText(itemid) {
      window.gtag('event', 'InputProfText', {
        cpno: window.Laravel.cpno,
        items_id: itemid
      })
    }
  }
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/StoryRecomend.vue